import { AccumulatorPanel } from "./EmployeeStopLoss";

const skipKeys = new Set(["details", "hasVersionExpired", "type"]);

const trackerRowFromModal = (data) => {
    if (!data || typeof data !== "object") return {};
    const { details, ...row } = data;
    const fromDetails = details && typeof details === "object" && !Array.isArray(details)
        ? details
        : {};
    const merged = { ...fromDetails, ...row };
    return Object.fromEntries(
        Object.entries(merged).filter(([key]) => !skipKeys.has(key))
    );
};

const ReinsuranceTrackerDetail = ({ data }) => {
    const row = trackerRowFromModal(data);
    const subtitle = [
        row.ClientID && `Client ${row.ClientID}`,
        row.BlkOfBusID && `Blob ${row.BlkOfBusID}`,
        row.LocationName,
        row.StopLossContractName,
        row.EmployeeID && `Employee ${row.EmployeeID}`,
        row.DependentID && `Dependent ${row.DependentID}`,
        row.EffectiveDate && `as of ${row.EffectiveDate}`,
    ].filter(Boolean).join(" · ");

    return (
        <AccumulatorPanel
            rows={[row]}
            title={row.StopLossContractName || row.ClientID || row.EmployeeID || "Reinsurance tracker"}
            subtitle={subtitle || "Click a view to load the linked Javelina record."}
            employeeId={row.EmployeeID}
            certificateNumber={row.CertificateNumber}
            dependentId={row.DependentID}
            effectiveDate={row.EffectiveDate}
            variant="dashboard"
            drawerZIndex={10050}
        />
    );
};

export default ReinsuranceTrackerDetail;
